import React from 'react';
import { HotelFacts, HotelFactsMobile } from '@lt/components';
import classnames from 'classnames';
import type { HotelFactsType } from '../../store/selectors/hotel';

import getFactsItemData from '../../utils/getFactsItemData';
import { HOTEL_FACTS_ORDER } from '../../constants/hotelFacts';
import FactsIcon from './FactsIcon';

import styles from './facts.module.css';

type FactsProps = {
  isMobile: boolean;
  facts: HotelFactsType;
};

const Facts = ({ isMobile = false, facts }: FactsProps): JSX.Element | null => {
  const factsData = HOTEL_FACTS_ORDER.map((type) => {
    const item = getFactsItemData(type, facts[type]);
    return item
      ? {
          ...item,
          icon: <FactsIcon type={item.iconName} isMobile={isMobile} />,
        }
      : null;
    // Костылек с type predicate, потому что ts не может сам определить тип после filter
  }).filter((el): el is Exclude<typeof el, null> => el !== null);

  const Component = isMobile ? HotelFactsMobile : HotelFacts;

  return (
    <Component
      facts={factsData}
      className={classnames({
        [styles.hotelFactsMobile]: isMobile,
      })}
    />
  );
};

export default Facts;
